import axios from "axios";
import {API_URL, AUTH_API_URL } from "./constants";
import {redirectUrl} from "../router/paths";
import uuid from 'uuidv4';
import {auth} from "./auth";
import {InitSession} from "./SessionTracker";

const axios_ = axios.create();
axios_.defaults.baseURL = API_URL;

axios_.interceptors.request.use(
  config => {
    let accessToken = auth.getAccessToken();
    if (accessToken) config.headers.authorization = 'bearer ' + accessToken;
    config.headers['Request-ID'] = uuid();
    return config;
  },
  error => Promise.reject(error)
);

const serialiseObject = (obj) => {
  let pairs = [];
  for (let prop in obj) {
    if (!obj.hasOwnProperty(prop)) continue;
    if (typeof prop == 'object') {
      pairs.push(serialiseObject(obj[prop]));
      continue;
    }
    pairs.push(prop + '=' + obj[prop]);
  }
  return pairs.join('&');
};

export const api = {
  request: ({method, url, data, headers = {},  responseType, timeout = 180000}) =>
    axios_({method, url, data, headers,  responseType, timeout}),
  getToken: (code) => {
    return axios({
      url:AUTH_API_URL + '/token',
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': "Basic " + btoa(window.CONFIG.CLIENT_ID + ":" + window.CONFIG.CLIENT_SECRET),
        'Request-ID': uuid(),
      },
      data: serialiseObject({
        grant_type: 'authorization_code',
        client_id: window.CONFIG.CLIENT_ID,
        client_secret: window.CONFIG.CLIENT_SECRET,
        scope: 'all',
        redirect_uri: redirectUrl,
        code: code
      })
    }).then((res) => {
      if (res.data.access_token) {
        localStorage.setItem('token', JSON.stringify(res.data))
        InitSession.setTokenLifetime(auth.getExpiresIn())
      }
    }).catch((err)=>console.log("err getToken", err))
  },
  refreshToken: () => {
    const refreshToken = auth.getRefreshToken();
    if (!refreshToken) return Promise.reject();
    console.log(`### refresh`);
    return axios.create()({
      url: AUTH_API_URL + '/token',
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': "Basic " + btoa(window.CONFIG.CLIENT_ID + ":" + window.CONFIG.CLIENT_SECRET),
        'Request-ID': uuid()
      },
      data: serialiseObject({
        grant_type: 'refresh_token',
        refresh_token: refreshToken
      })
    }).then((res) => {
      if (res.data.access_token) {
        localStorage.setItem('token', JSON.stringify(res.data));
        return auth.getExpiresIn();
      }
    }).then(data => {
      InitSession.setTokenLifetime(data)
    }).catch((e) => {
      localStorage.removeItem('token');
      localStorage.removeItem('expires_in');
      window.location.reload();
    })
  },
  logout: () => {
    localStorage.removeItem('token');
    return Promise.resolve()
  }
};

